export default __webpack_public_path__ + "static/media/zoneOn.79c87280.svg";